<template>
  <div class="rewards">
    <div
      class="greeting px-4 white"
      style="top: 63px; z-index: 5; width: min(100vw, 480px)"
    >
      <v-divider class="opacity-50" />

      <div class="rewards-header">
        <div
          class="w-100 pt-6 pb-2"
          :class="{
            'mb-n2': shouldShowFilter,
            'd-flex justify-space-between align-center': !shouldShowFilter
          }"
        >
          <h3>My Rewards</h3>
          <div class="d-flex justify-content-between align-center">
            <v-select
              v-if="shouldShowFilter"
              v-model="dealSelected"
              class="rewards-select mt-4 mb-n3"
              density="compact"
              item-title="name"
              :items="deals"
              :list-props="{ density: 'compact' }"
              :menu-props="{ contentClass: 'rewards-select-menu', maxHeight: 280 }"
              :menu-icon="null"
              persistent-hint
              return-object
              variant="outlined"
            >
              <template v-slot:selection="{ item }">
                <span class="rewards-select__selection">
                  {{ item?.title ?? dealSelected?.name }}
                </span>
              </template>
              <template v-slot:append-inner>
                <icon fill="black" height="12" width="12">angle-down</icon>
              </template>
            </v-select>

            <router-link
              class="d-flex align-center text-grey-darken-2 ms-2 font-weight-bold"
              :to="{
                name: 'RewardsHistory',
                query: { t: $route.query.t }
              }"
            >
              <v-chip color="primary" rounded="pill" variant="flat">
                
                <icon
                  class="me-1"
                  fill="white"
                  height="38"
                  link
                  width="18"
                >
                  Rewards
                </icon>                
                {{
                  dealSelected
                    ? dealSelected.current_points
                    : points.current_points
                }}
              </v-chip>
            </router-link>
          </div>
        </div>
        <div v-if="currentItem.points_valid_until" class="pb-4 caption">
          {{
            $moment().isBefore(currentItem.points_valid_until)
              ? 'Redeem prizes using points until'
              : 'Points expired on'
          }}
          <span class="font-weight-bold">
            {{ $moment(currentItem.points_valid_until).format('MMM D, YYYY') }}
          </span>
        </div>
      </div>
    </div>

    <v-divider class="opacity-50" />

    <module-renderer location="cart" :module-data="moduleData" />

    <template v-if="sortedData.length < 1">
      <v-alert border="start" class="ma-4" type="info">
        <template v-slot:prepend>
          <div class="align-self-start me-4">
            <icon fill="white" height="20" width="20">info-circle</icon>
          </div>
        </template>
        There are no additional rewards available at this time. Please check
        back later to see if this page has been updated.
      </v-alert>
    </template>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';

export default {
  name: 'Rewards',
  data() {
    return {
      selected: null
    };
  },
  methods: {
    ...mapActions('cartAssignments', ['getAssignments']),
    ...mapActions('cartProducts', ['setPrizesDealId'])
  },
  computed: {
    ...mapGetters('cartAssignments', { findAssignments: 'find' }),
    ...mapGetters('deals', ['getGamifiedDealsWithOrders']),
    ...mapState(['messages', 'offer', 'points']),
    currentItem() {
      return this.dealSelected ? this.dealSelected : this.offer;
    },
    deals() {
      return [...this.getGamifiedDealsWithOrders].sort((a, b) => {
        if (a.points_valid_until && b.points_valid_until) {
          return (
            new Date(b.points_valid_until) - new Date(a.points_valid_until)
          );
        }

        if (b.points_valid_until) return -1;

        if (a.points_valid_until) return 1;

        return 0;
      });
    },
    dealSelected: {
      get() {
        return this.selected || this.deals[0];
      },
      set(dealSelected) {
        // when selecting I need to filter out the deals to show
        this.setPrizesDealId(dealSelected);
        return (this.selected = dealSelected);
      }
    },

    moduleData() {
      // In this case the assignmentId (2nd param) is also the offerId
      const { id: assignmentId } = this.offer;
      const assignment = this.findAssignments(assignmentId);
      return assignment.modules || [];
    },
    shouldShowFilter() {
      return !this.offer.use_points && this.deals.length > 1;
    },
    sortedData() {
      return this?.moduleData?.[0]?.data?.sorted || [];
    }
  },
  async created() {
    await this.getAssignments({
      assignmentId: this.offer.id,
      location: 'redeem',
      offerId: this.offer.id,
      type: 'offer'
    });

    if (!this.offer.use_points) {
      // set the filter initially and grab first deals products for /itemCards/index.vue
      const selected = this.selected || this.deals[0];
      this.setPrizesDealId(selected);
    }
  }
};
</script>

<style lang="scss" scoped>
.reward-card {
  &__venue-name {
    color: #6c6c6c;
    font-size: 13px;
  }

  &__points-to-go {
    color: #414141;
  }
}

.rewards-select {
  &__selection {
    font-size: 12px;
    line-height: 1;
  }

  .v-field__append-inner {
    align-items: center;
    padding-top: 0;
  }
}

.v-chip.v-chip--size-default {
  --v-chip-size: 0.875rem;
  --v-chip-height: 38px;
  font-size: 0.875rem;
  padding: 0 20px;
}

.rewards-select-menu {
  border-radius: 4px;
  overflow: hidden;

  .v-list {
    padding: 4px 0;
  }

  .v-list-item {
    font-size: 0.75rem;
    min-height: 36px;
    padding-inline: 16px;
  }

  .v-list-item__content,
  .v-list-item-title {
    font-size: inherit;
  }
}

.v-application .v-chip {
    font-weight: 700 !important;
}
</style>
